import { AxiosResponse } from "axios";
import getEnv from "env";
import { get } from "api";

const env = {
  getConfig: (): Promise<AxiosResponse> => {
    return get(getEnv().sharedConfigUrl);
  },
  getGlobalBannerConfig: (): Promise<AxiosResponse> => {
    return get(getEnv().globalBannerConfigUrl);
  },
};

export default env;
